import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

import styled from "styled-components";

const Item = styled.li`
	height: 50px;
	text-align: center;
`;

const MenuItem = (props) => {
	const [hover, setHover] = useState(false);
	return (
		<Item
			onMouseOver={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
		>
			<NavLink
				to={props.to}
				exact
				activeClassName="myTestClass"
				activeStyle={{ background: "wheat" }}
			>
				<FontAwesomeIcon
					className="bx bx-grid-alt"
					icon={props.icon}
					size="2x"
					style={hover ? { color: "red" } : {}}
					inverse
				></FontAwesomeIcon>
				<span className="links_name">{props.name}</span>
			</NavLink>
			<span className="tooltip">{props.name}</span>
		</Item>
	);
};

export default MenuItem;
